import React, { useState } from "react";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { auth, db } from "../../firebase";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCart } from "../../cart/CartContext"; // 🛒 נביא את העגלה

export default function SignupPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // 🔥 זה החדש:
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const navigate = useNavigate();
  const { items } = useCart(); // 🛒 מה יש בעגלה כרגע
  const hasCartItems = items && items.length > 0;

  // 🔥 EMAIL SIGNUP
  const handleSignup = async (e) => {
    e.preventDefault();

    if (!acceptedTerms) {
      toast.error("You must agree to the Terms and Privacy Policy.");
      return;
    }

    setLoading(true);

    try {
      const userCred = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      await setDoc(doc(db, "users", userCred.user.uid), {
        email,
        signUpStage: "detailsIncomplete",
        createdAt: new Date(),
      });

      toast.success("Welcome aboard 🌿");

      // 🧠 אם יש מוצרים בעגלה → לעגלה, אחרת → products
      navigate(hasCartItems ? "/cart" : "/products");
    } catch (err) {
      toast.error(err.message.replace("Firebase:", "").trim());
    } finally {
      setLoading(false);
    }
  };

  // 🔥 GOOGLE SIGNUP
  const handleGoogleSignup = async () => {
    if (!acceptedTerms) {
      toast.error("You must agree to the Terms and Privacy Policy.");
      return;
    }

    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);

      await setDoc(doc(db, "users", result.user.uid), {
        email: result.user.email,
        signUpStage: "detailsIncomplete",
        createdAt: new Date(),
      });

      toast.success("Signed up with Google 🌿");

      // 🧠 גם כאן – אם יש מוצרים בעגלה → לעגלה, אחרת → products
      navigate(hasCartItems ? "/cart" : "/products");
    } catch (err) {
      toast.error("Google signup failed: " + err.message);
    }
  };

  const buttonText = "Sign Up";
  const googleHandler = handleGoogleSignup;

  return (
    <div
      style={{
        minHeight: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f9f9f9, #f0f4f7)",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          width: "100%",
          maxWidth: 420,
          padding: "40px 30px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            marginBottom: 20,
            color: "#222",
            letterSpacing: "0.5px",
            fontWeight: 600,
          }}
        >
          Create your account
        </h2>

        <form
          onSubmit={handleSignup}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={inputStyle}
          />
          <input
            type="password"
            placeholder="Password (min 6 characters)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={inputStyle}
          />

          {/* 🔥 TERMS CHECKBOX */}
          <div
            style={{
              width: "100%",
              maxWidth: 300,
              marginTop: 15,
              marginBottom: 5,
              textAlign: "left",
              fontSize: "14px",
              display: "flex",
              alignItems: "flex-start",
              gap: 8,
            }}
          >
            <input
              type="checkbox"
              checked={acceptedTerms}
              onChange={() => setAcceptedTerms(!acceptedTerms)}
              style={{ marginTop: 2 }}
            />
            <label style={{ color: "#444", lineHeight: "1.4" }}>
              I agree to the{" "}
              <a
                href="/terms"
                style={{ color: "#0078ff", textDecoration: "underline" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Use
              </a>{" "}
              and{" "}
              <a
                href="/privacy"
                style={{ color: "#0078ff", textDecoration: "underline" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              .
            </label>
          </div>

          {/* 🔥 שני הכפתורים */}
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <button
              type="submit"
              disabled={loading}
              style={{
                ...buttonStyle,
                background: loading
                  ? "#ccc"
                  : "linear-gradient(90deg, #222, #444)",
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Creating..." : buttonText}
            </button>

            <button
              type="button"
              onClick={googleHandler}
              style={{
                ...buttonStyle,
                background: "#fff",
                color: "#444",
                border: "1px solid #ccc",
                marginTop: 12,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
              }}
            >
              <img
                src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                alt="Google"
                style={{ width: 20, height: 20 }}
              />
              Continue with Google
            </button>
          </div>
        </form>

        <p style={{ marginTop: 20, color: "#555" }}>
          Already have an account?{" "}
          <span
            onClick={() => navigate("/login")}
            style={{
              color: "#0078ff",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            Log in
          </span>
        </p>
      </div>
    </div>
  );
}

const inputStyle = {
  display: "block",
  width: "100%",
  maxWidth: 300,
  margin: "10px auto",
  padding: "12px 14px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  fontSize: "15px",
  outline: "none",
  textAlign: "center",
  transition: "border 0.2s ease",
};

const buttonStyle = {
  width: "100%",
  maxWidth: 300,
  padding: "12px",
  border: "none",
  borderRadius: "8px",
  fontSize: "16px",
  fontWeight: 600,
  transition: "opacity 0.2s ease",
};
